module.exports = __webpack_public_path__ + "img/4.8d2a10a3.svg";